import {AbstractProductSlide} from "./abstract-product-slide";

export default class UnfocusProductSlide extends AbstractProductSlide
{
    create(): any {
        let $pintrest = this.$element.find('.js-product-slides__slide-pin');
        let $wishlist = this.$element.find('.alg-wc-wl-btn');
        let $target = this.$element.find('.js-product-slides__slide-info');
        let $callToAction = $target.find('.js-product-slides__call-to-action');
        let contractedHeight = this.getContractedHeight($target);
        return this
            .timeline
            .to($target, 0.1, { backgroundColor: '#F1F1F1', ease: 'sine.easein' }, 0)
            .to($callToAction.add($pintrest).add($wishlist), 0.1, { opacity: 0, ease: 'sine.easeIn' }, 0)
            .to($target, 0.2, { height: contractedHeight, ease: 'power3.easeOut' })
            .call(() => {
                $wishlist.removeClass('alg-wc-wl-btn--active');
                $callToAction.attr('hidden', 'hidden');
                $target.data('contracted_height', null);
                $target.data('expanded_height', null);
            })
            .set($target, { clearProps: 'all' })
        ;
    }
}